export default "__VITE_ASSET__3dfff9aa__"